import React from "react";
import { Typography } from "@mui/material";
import { useStore } from "../store/store";
import { styled } from "@mui/material/styles";

const StyledWrap = styled("div")({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  paddingTop: 10,
});

const StyledDiv = styled("div")({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "flex-start",
  paddingTop: 10,
});

const ErrorMsgs = () => {
  const doorType = useStore((state) => state.quote.doorType);

  const material = useStore((state) => state.quote.material);
  const woodSpecies = useStore((state) => state.quote.woodSpecies);

  const unitSize = useStore((state) => state.quote.unitSize);
  const cornerWidthRight = useStore((state) => state.quote.cornerWidthRight);

  const comboWindowUnitSize = useStore((state) => state.quote.comboWindowUnitSize);

  const height = useStore((state) => state.quote.height);
  const comboWindowHeight = useStore((state) => state.quote.comboWindowHeight);

  const pivotHardware = useStore((state) => state.quote.pivotHardware);
  const pivotAction = useStore((state) => state.quote.pivotAction);

  const exactConfig = useStore((state) => state.quote.exactConfig);
  const cornerConfigRight = useStore((state) => state.quote.cornerConfigRight);
  const comboWindowConfig = useStore((state) => state.quote.comboWindowConfig);

  const sideLite = useStore((state) => state.quote.sideLite);
  const swingPanelWidth = useStore((state) => state.quote.swingPanelWidth);

  const errors = useStore((state) => state.errors);

  const isCorner = doorType?.includes("Corner");
  const isCombo = doorType?.includes("Combo");

  let errArray: string[] = [];

  if (!material) {
    errArray.push("Select a Material");
  }

  if (material !== "All Aluminum" && !woodSpecies) {
    errArray.push("Select a Wood Species");
  }

  if (isCorner) {
    if (errors.widthErr) {
      errArray.push(errors.widthErr);
    } else if (!unitSize) {
      errArray.push("Enter a Left Frame Width");
    }

    if (errors.widthErrCornerRight) {
      errArray.push(errors.widthErrCornerRight);
    } else if (!cornerWidthRight) {
      errArray.push("Enter a Right Frame Width");
    }
  }else if(isCombo){
    if (errors.widthErr) {
      errArray.push(errors.widthErr);
    } else if (!unitSize) {
      errArray.push("Enter a Door Frame Width");
    }

    if (errors.widthErrComboWindow) {
      errArray.push(errors.widthErrComboWindow);
    } else if (!comboWindowUnitSize) {
      errArray.push("Enter a Window Frame Width");
    }
  } else {
    if (errors.widthErr) {
      errArray.push(errors.widthErr);
    } else if (!unitSize) {
      errArray.push("Enter a Frame Width");
    }
  }

  if(isCombo){
    if (errors.heightErr) {
      errArray.push(errors.heightErr);
    } else if (!height) {
      errArray.push("Enter a Door Frame Height");
    }

    if (errors.heightErrComboWindow) {
      errArray.push(errors.heightErrComboWindow);
    } else if (!comboWindowHeight) {
      errArray.push("Enter a Window Frame Height");
    }
  }else{
    if (errors.heightErr) {
      errArray.push(errors.heightErr);
    } else if (!height) {
      errArray.push("Enter a Frame Height");
    }
  }

  if (errors.configErr) {
    errArray.push(errors.configErr);
  } else if (isCorner) {
    if (!exactConfig) errArray.push("Select a Left Configuration");
    if (!cornerConfigRight) errArray.push("Select a Right Configuration");
  } else if(isCombo){
    if (!exactConfig) errArray.push("Select a Door Configuration");
    if (!comboWindowConfig) errArray.push("Select a Window Configuration");
  }else if (!exactConfig) {
    errArray.push("Select a Configuration");
  }

  if (doorType === "Pivot") {
    if (!pivotHardware) errArray.push("Select a Pivot Hardware");
    if (!pivotAction) errArray.push("Select a Pivot Movement");
  }

  if (errors.jambErr) {
    errArray.push(errors.jambErr);
  }

  if (errors.primaryDoorErr) {
    errArray.push(errors.primaryDoorErr);
  }

  if (errors.withExtSboltErr) {
    errArray.push(errors.withExtSboltErr);
  }

  if (errors.swingWidthErr) {
    if (isCorner) {
      errArray.push(errors.swingWidthErr);
    } else {
      errArray.push(`Panel Width should be ${errors.swingWidthErr}`);
    }
  } else if (
    (doorType === "Swing" || doorType === "Pivot") &&
    sideLite !== "none" &&
    !swingPanelWidth
  ) {
    errArray.push("Enter a Panel Width");
  }

  if (errors.sideliteWidthErr) {
    errArray.push(errors.sideliteWidthErr);
  }

  if (errors.pivotPointErr) {
    errArray.push(`Pivot Point ${errors.pivotPointErr}`);
  }

  return (
    <StyledWrap>
      <StyledDiv>
        {errArray.length > 0 ? (
          <Typography
            style={{ color: "red", fontWeight: "bold" }}
            variant="body1"
          >
            Fix Errors:
          </Typography>
        ) : null}

        {errArray.length > 0
          ? errArray.map((err) => <ErrorBody err={err} />)
          : null}
      </StyledDiv>
    </StyledWrap>
  );
};

const ErrorBody: React.FC<{ err: string }> = ({ err }) => {
  return (
    <Typography style={{ color: "red" }} variant="body1">
      - {err}
    </Typography>
  );
};

export default ErrorMsgs;
